<template>
  <div data-test-id="roles-tab-menu">
    <div
      class="bg-responsive-white q-pt-sm sticky-search-container"
    >
      <div class="row q-mb-md no-wrap items-center">
        <div class="col">
          <q-input
            v-model.trim="searchString"
            label="Search"
            dense
            clearable
            debounce="500"
            :disable="roles.loading"
          />
        </div>
        <div class="col-auto">
          <q-btn
            class="q-pl-sm"
            :label="$q.screen.gt.sm ? 'Select All' : 'All'"
            flat
            dense
            :ripple="false"
            @click="selectAll"
          />
        </div>
      </div>
    </div>
    <q-list>
      <q-item v-if="$_.isEmpty(roles.data)">
        <q-item-section>
          <q-item-label>
            No Roles configured
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-item
        v-for="role in roles.data"
        :key="role.id"
        clickable
        @click.stop="handleRoleClick(role)"
      >
        <q-item-section avatar>
          <q-checkbox
            class="no-pointer-events"
            :model-value="isRoleCoveredByPreviewedPermissionActions(role)"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label class="text-subtitle1">
            {{ role.name }}
          </q-item-label>
          <q-item-label class="text-responsive-grey-9">
            {{ role.permissionCount }} permissions
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
    <q-inner-loading :showing="roles.loading" />
  </div>
</template>

<script>
export default {
  name: 'RolesTabMenu',
  props: {
    previewedPermissionActions: {
      type: Array,
      required: true
    }
  },
  emits: ['unselect-permission-actions', 'select-permission-actions'],
  data () {
    return {
      searchString: ''
    }
  },
  models: {
    roles: {
      rolePermissions: {
        action: true,
        permission: 'default'
      },
      variables () {
        return {
          searchString: this.searchString
        }
      }
    }
  },
  methods: {
    handleRoleClick (role) {
      if (_.isEmpty(role.permissionActions)) return

      if (this.isRoleCoveredByPreviewedPermissionActions(role)) {
        this.$emit('unselect-permission-actions', role.permissionActions)
      } else {
        this.$emit('select-permission-actions', role.permissionActions)
      }
    },
    isRoleCoveredByPreviewedPermissionActions (role) {
      return !_.isEmpty(role.permissionActions) && _.every(role.permissionActions, action => {
        return _.includes(this.previewedPermissionActions, action)
      })
    },
    selectAll () {
      this.$emit('select-permission-actions', _.flatten(_.map(this.roles.data, 'permissionActions')))
    }
  }
}
</script>

<style scoped>
.sticky-search-container {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
